import { createContext } from 'react'

export interface LoadingStateContextType {
  isLoading: boolean
}

export interface LoadingActionsContextType {
  startLoading: () => void
  stopLoading: () => void
}

export const LoadingStateContext = createContext<LoadingStateContextType | undefined>(undefined)
export const LoadingActionsContext = createContext<LoadingActionsContextType | undefined>(undefined)
